<template>
    <BaseLink
        :externalTo="VUE_APP_ANDROID_APP_URL"
        target="_blank"
        :class="$style.android_link"
    >
        <img
            :src="AndroidAppBadgeImg"
            alt="Playgama Android"
            loading="lazy"
            :class="$style.android_badge"
        />
        <Typography
            size="s"
            :class="$style.android_link_desc"
            accent
        >
            {{ $tr('navigation.android_app_link') }}
        </Typography>
        <Icon
            name="chevron_r"
            :class="$style.android_link_icon"
        />
    </BaseLink>
</template>

<script setup lang="ts">
import BaseLink from '@/components_new/BaseLink.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { useConfig } from '@/composables/config'

import AndroidAppBadgeImg from '../images/android_image.svg'

const { VUE_APP_ANDROID_APP_URL } = useConfig()
</script>

<style module>
.android_link {
    display: flex;
    padding: 8px;
    gap: 10px;
    background-color: var(--carbon-300);
    border-radius: 12px;
    gap: 10px;
    align-items: center;
}

.android_badge {
    width: 126px;
}

.android_link_icon {
    flex-shrink: 0;
    margin-left: auto;
    color: var(--white-20);
}

.android_link_desc {
    color: var(--white-80);
}

/* for seo purposes */
@media (--tablet-plus) {
    .android_link {
        height: 0;
        width: 0;
        visibility: hidden;
        overflow: hidden;
        padding: 0;
    }
}
</style>
